import { GDFWmoVolcano2Record } from '../../gdf/type';
import { getCopyButtonComponent } from '../copy-button';

export default function WmoVolcano2Properties({ record }: { record: GDFWmoVolcano2Record }) {
    const Button = getCopyButtonComponent();
    return (
        <div>
            {Button && (
                <div className="pb-2 d-flex justify-content-end">
                    <Button getText={() => record.properties} />
                </div>
            )}
            <pre className="secondary-bg-color p-2">{record.properties || "No details found."}</pre>
        </div>
    );
}
